import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import {
  ApplicationConfig,
  ErrorHandler,
  provideZoneChangeDetection,
} from "@angular/core";
import { provideNativeDateAdapter } from "@angular/material/core";
import {
  provideRouter,
  RouteReuseStrategy,
  withComponentInputBinding,
} from "@angular/router";
import { provideNgIdle } from "@ng-idle/core";
import { provideToastr } from "ngx-toastr";

import { provideMaterialConfigs } from "components/material/configs/material-configs.provider";
import { provideMatDialogInitializer } from "components/material/initializers/mat-dialog.initializer";
import { provideMatIconInitializer } from "components/material/initializers/mat-icon.initializer";
import { provideI18n } from "core/i18n/i18n.provider";
import { provideFeatureFlags } from "features/feature-flags/feature-flags.provider";
import { GlobalErrorHandler } from "interceptors/global-error-handler";
import { provideHttpInterceptors } from "interceptors/interceptors.provider";
import { ExplicitQueryParamsReactivateStrategy } from "router/route-reuse-strategies/explicit-query-params-reactivate.strategy";
import { APP_ROUTES } from "screens/app/app.routes";

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(), // TODO: migrate to zoneless change detection
    provideHttpClient(withInterceptorsFromDi()),
    provideHttpInterceptors(),
    provideRouter(APP_ROUTES, withComponentInputBinding()),
    {
      provide: RouteReuseStrategy,
      useClass: ExplicitQueryParamsReactivateStrategy,
    },
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    provideFeatureFlags(),
    provideI18n(),
    provideToastr(),
    provideMatIconInitializer(),
    provideMatDialogInitializer(),
    provideMaterialConfigs(),
    provideNativeDateAdapter(),
    provideNgIdle(),
  ],
};
